var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list',{attrs:{"color":"transparent"}},[_c('v-list-item',{staticClass:"px-0"},[_c('v-list-item-content',[_c('div',{staticClass:"font-size-03"},[_vm._v(" "+_vm._s(_vm.$t('add-nuki-bridge-dialog.step-finish.description'))+" ")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }